import { useCallback } from "react";

import * as Shared from "../../../../_shared";

export const useSellingPrice = () => {
	const { viewModel, onSetViewModel } = Shared.Model.Context.useMarketingVoucherEditContext();
	const { sellingPrice } = viewModel;

	const onSetSellingPriceAmount = useCallback(
		(input: number | undefined) => {
			onSetViewModel([
				{
					key: "sellingPrice",
					value: {
						...sellingPrice,
						amount: {
							isEdited: true,
							value: input!,
						},
					},
				},
			]);
		},
		[onSetViewModel, sellingPrice],
	);

	return {
		sellingPrice,
		onSetSellingPriceAmount,
	};
};
